var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.33334H6.66659C5.93021 5.33334 5.33325 5.9303 5.33325 6.66668V13.3333C5.33325 14.0697 5.93021 14.6667 6.66659 14.6667H13.3333C14.0696 14.6667 14.6666 14.0697 14.6666 13.3333V6.66668C14.6666 5.9303 14.0696 5.33334 13.3333 5.33334Z",
    stroke: "#e4002b",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66659 10.6667C1.93325 10.6667 1.33325 10.0667 1.33325 9.33335V2.66668C1.33325 1.93334 1.93325 1.33334 2.66659 1.33334H9.33325C10.0666 1.33334 10.6666 1.93334 10.6666 2.66668",
    stroke: "#e4002b",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.85db64a6b3d0c2054d019ae3c173b226.svg";
export { ForwardRef as ReactComponent };